export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";
export const RESET_MODE = "RESET_MODE";